module.exports = __webpack_public_path__ + "static/fbook-3d8bc70d3c0521c861f6ce5497aac84b.png";